var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:{ active: _vm.menuOpen },on:{"click":_vm.clickSideBar}},[_c('side-nav-component')],1)}
var staticRenderFns = []

export { render, staticRenderFns }